var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHangup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 5.05078C0.359375 4.61328 0.414062 4.09375 0.769531 3.73828C2.13672 2.37109 5.03516 0.375 9 0.375C12.9375 0.375 15.8359 2.37109 17.2031 3.73828C17.5586 4.09375 17.6133 4.61328 17.4219 5.05078L16.2734 7.62109C16.1094 8.00391 15.6992 8.19531 15.2891 8.11328L12.3086 7.53906C11.8984 7.45703 11.625 7.10156 11.625 6.66406V4.3125C9.90234 3.76562 8.07031 3.76562 6.375 4.3125V6.66406C6.375 7.10156 6.07422 7.45703 5.66406 7.53906L2.68359 8.11328C2.27344 8.19531 1.86328 8.00391 1.69922 7.62109L0.550781 5.05078Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangup);
export default __webpack_public_path__ + "static/media/hangup.855e050c425b6c1e3058114566a617cc.svg";
export { ForwardRef as ReactComponent };